import { alpha } from '@mui/material/styles';
import type { SxProps, Theme } from '@mui/material';

export const modernBookSectionSx: SxProps<Theme> = {
  minWidth: 0,
  scrollMarginTop: 150,
};

export const modernBookNavigationSx: SxProps<Theme> = (theme) => ({
  position: { xs: 'static', lg: 'sticky' },
  top: 80,
  zIndex: theme.zIndex.appBar - 1,
  mb: 3,
  px: 1,
  py: 0.75,
  overflowX: 'auto',
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 2,
  bgcolor: alpha(theme.palette.background.default, theme.palette.mode === 'dark' ? 0.92 : 0.96),
  boxShadow: theme.shadows[1],
  backdropFilter: 'blur(10px)',
  '&::-webkit-scrollbar': { height: 6 },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: 999,
    bgcolor: alpha(theme.palette.primary.main, 0.2),
  },
});

export const modernBookActionsSx: SxProps<Theme> = (theme) => ({
  position: 'relative',
  zIndex: 1,
  mt: 3,
  p: { xs: 1.5, md: 2 },
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 2.5,
  bgcolor: alpha(theme.palette.background.default, theme.palette.mode === 'dark' ? 0.94 : 0.97),
  boxShadow: theme.shadows[1],
  backdropFilter: 'blur(12px)',
});
